export default "__VITE_ASSET__By65pEZm__";